import { Reveal, ChapterLabel } from "./Reveal";

export const WhoWeAre = () => (
  <section data-testid="who-we-are-section" className="bg-[#F3F4F6] py-24 sm:py-32 px-6 sm:px-10">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal>
          <ChapterLabel number="01" title="Who We Are" />
          <p className="font-heading mt-8 text-[92px] sm:text-[140px] leading-none font-black text-[#0B1B3D]/10 select-none">
            DPM
          </p>
          <div data-testid="travis-portrait-block" className="mt-10 max-w-[300px]">
            <div className="relative">
              <div className="absolute -bottom-3 -right-3 w-full h-full border border-[#C5A059]" />
              <div className="relative aspect-[4/5] bg-[#0B1B3D] overflow-hidden">
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <span className="font-heading text-6xl font-black text-white/15 select-none">TM</span>
                </div>
                <img
                  src="/travis-mack.jpg"
                  alt="Travis Mack, Founder & CEO"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              </div>
            </div>
            <p className="font-heading mt-7 text-lg font-bold tracking-tight text-[#0B1B3D]">
              Travis Mack
            </p>
            <p className="mt-1 text-[10px] font-semibold tracking-[0.25em] uppercase text-[#4B5563]">
              Founder &amp; CEO — U.S. Navy Veteran
            </p>
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal delay={0.15}>
          <p data-testid="who-we-are-text" className="text-xl sm:text-2xl lg:text-[1.7rem] leading-relaxed sm:leading-relaxed text-[#0B1B3D] font-light">
            <span className="font-semibold">Defense Precision Machining (DPM)</span> is a state-of-the-art,
            high-compliance precision CNC machining organization purpose-built to serve the most demanding
            requirements of the aerospace and defense sectors. Founded and led by{" "}
            <span className="font-semibold">Travis Mack</span>, DPM delivers mission-critical, tight-tolerance
            components to the aerospace and defense community, and is{" "}
            <span className="border-b-2 border-[#C5A059]">
              actively seeking to acquire established precision machine shops
            </span>{" "}
            to expand capacity, capability, and reach across the defense industrial base.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
